module.exports = __webpack_public_path__ + "static/media/4.80aedcd4.JPG";